export { useAdobeTarget } from "./use-adobe-target";
